import React from "react";
import {
  CreateAccountDesktopContainer,
  CreateAccountDesktopColorBackground,
  CreateAccountDesktopGradientLayer,
  CreateAccountDesktopBrandPanel,
  CreateAccountDesktopBrandLockup,
  CreateAccountDesktopFormCell,
  CreateAccountNonDesktopShell,
  CreateAccountHeroBand,
  CreateAccountHeroLockupImg,
  CreateAccountNonDesktopContents,
} from "./CreateAccountForm.styles";
import unityLockup from "../../assets/logos/unity-rebrand/unity-vert-cobranded.svg";
import unityLockupHorizontal from "../../assets/logos/unity-rebrand/unity-horiz-cobranded.svg";

import { CreateAccountFormContent } from "./CreateAccountFormContent";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

export const CreateAccountForm: React.FC<{ setPathname: () => void }> = ({
  setPathname,
}) => {
  const { isDesktop } = useDeviceHook();

  return (
    <>
      {isDesktop && (
        <CreateAccountDesktopContainer>
          <CreateAccountDesktopColorBackground>
            <CreateAccountDesktopGradientLayer aria-hidden />
            <CreateAccountDesktopBrandPanel>
              <CreateAccountDesktopBrandLockup
                src={unityLockup}
                alt="Unity by BillionToOne"
              />
            </CreateAccountDesktopBrandPanel>
          </CreateAccountDesktopColorBackground>
          <CreateAccountDesktopFormCell>
            <CreateAccountFormContent setPathname={setPathname} />
          </CreateAccountDesktopFormCell>
        </CreateAccountDesktopContainer>
      )}
      {!isDesktop && (
        <CreateAccountNonDesktopShell>
          <CreateAccountHeroBand>
            <CreateAccountHeroLockupImg
              src={unityLockupHorizontal}
              alt="Unity by BillionToOne"
            />
          </CreateAccountHeroBand>
          <CreateAccountNonDesktopContents>
            <CreateAccountFormContent setPathname={setPathname} />
          </CreateAccountNonDesktopContents>
        </CreateAccountNonDesktopShell>
      )}
    </>
  );
};
